import { FC } from 'react'
import styles from 'components/features/socialFeed/ComposeNextToInput/ComposeNextToInput.styl'
import { WithComposeId } from 'interfaces/feed'
import { PostAddTagAction } from 'components/features/pfm/PostAddTagAction/PostAddTagAction'
import { ComposeErrors } from 'components/features/socialFeed/ComposeErrors/ComposeErrors'
import { useComposeState } from 'helpers/hookHelpers'

type ComposeNextToInputProps =
  & WithComposeId

export const ComposeNextToInput: FC<ComposeNextToInputProps> = (props) => {
  const { composeId } = props

  const { type } = useComposeState(composeId, { type: null })

  return (
    <div className={ styles.composeNextToInput }>
      { type === 'post' && (
        <div className={ styles.addTag }>
          <PostAddTagAction { ...props } />
        </div>
      )}
      <div className={ styles.error }>
        <ComposeErrors { ...props } />
      </div>
    </div>
  )
}
